import { http } from '@frontend/fetch';

export type LocationAccessRow = {
  ClientLocationID: string | null;
  ID: string;
  LocationID: string;
  SourceID: string;
  Type: 'all' | 'contact' | string;
};
export type LocationAccessResponse = LocationAccessRow[];

export type LocationChild = {
  Active: boolean;
  LocationID: string;
  Name: string;
  ParentID: string;
  PhoneTenantID: string;
  Slug: string;
  Type: number;
  Vertical: number;
  VerticalID: number;
  VerticalTextID: number;
};
export type LocationChildrenResponse = LocationChild[];

export type ClientLocationRow = {
  ClientLocationID: string;
  ExternalID: string;
  Name: string;
  ShortName: {
    value: string;
  };
  SourceID: string;
  CreatedAt: {
    seconds: number;
    nanos: number;
  };
  ModifiedAt: {
    seconds: number;
    nanos: number;
  };
  SourceTenantID: string;
};
export type ClientLocationResponse = ClientLocationRow[];

export type DataSourceSyncAppRow = {
  LocationID: string;
  SourceID: string;
  SourceName: string;
  CreatedAt: {
    seconds: number;
    nanos: number;
  };
};
export type DataSourceResponse = {
  SyncApps: DataSourceSyncAppRow[];
};

export type FeatureFlagsRow = {
  Name: string;
  Value: boolean;
  DisplayName: string;
};
export type FeatureFlagsResponse = FeatureFlagsRow[];

export const getSupportClientLocation = () => {
  return http.get<{ data: ClientLocationResponse }>('support/v1/client-location').then((response) => response.data);
};

export const getSupportLocationDatasource = () => {
  return http.get<{ data: DataSourceResponse }>('support/v1/datasource').then((response) => response.data);
};

export const getSupportLocationAccess = () => {
  return http.get<{ data: LocationAccessResponse }>('support/v1/access').then((response) => response.data);
};

export const getSupportLocationChildren = (locationId: string) => {
  return http
    .get<{ data: LocationChildrenResponse }>(`support/v1/location/${locationId}/children`)
    .then((response) => response.data);
};

export const getSupportLocationFeatureFlags = (locationId: string) => {
  return http
    .get<{ data: FeatureFlagsResponse }>(`support/v1/featureflags/${locationId}`)
    .then((response) => response.data);
};
